import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';
import useCurrentUser from './useCurrentUser';

const { user } = useCurrentUser();
const { addAlert } = useAlerts();

const REMINDER_MUTATION = gql`
  mutation UpdateReminder($reminderid: ID!, $reminder: TBL_REMINDERS_Input) {
    updateReminder(REMINDERID: $reminderid, reminder: $reminder)
  }
`;

const ADD_REMINDER_MUTATION = gql`
  mutation AddReminder($reminder: TBL_REMINDERS_Input) {
    createReminder(reminder: $reminder)
  }
`;

const DELETE_REMINDER_MUTATION = gql`
  mutation DeleteReminder($reminderid: ID!) {
    deleteReminder(REMINDERID: $reminderid)
  }
`;

const CLEAR_USER_REMINDERS_MUTATION = gql`
  mutation clearUserReminders($assignedid: ID!) {
    clearUserReminders(assignedid: $assignedid)
  }
`;

export default function useReminderMutate() {
  const { mutate, loading, error } = useMutation(REMINDER_MUTATION);
  const { mutate: addMutate } = useMutation(ADD_REMINDER_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_REMINDER_MUTATION);
  const { mutate: clearUserRemindersMutate } = useMutation(CLEAR_USER_REMINDERS_MUTATION);

  async function updateReminder(reminderid, reminder) {
    try {
      const { data } = await mutate({ reminderid, reminder });
      return data;
    } catch (error) {
      console.error('Error updating reminder:', error);
      addAlert('Error updating reminder', 'high', 4);
    }
  }

  async function addReminder(reminder) {
    try {
      const { data } = await addMutate({ reminder });
      return data;
    } catch (error) {
      console.error('Error adding reminder:', error);
      addAlert('Error adding reminder', 'high', 4);
      throw error;
    }
  }

  async function deleteReminder(reminderid) {
    try {
      const { data } = await deleteMutate({ reminderid });
      addAlert('Reminder deleted successfully', 'low', 2);
      return data;
    } catch (error) {
      console.error('Error deleting reminder:', error);
      addAlert('Error deleting reminder', 'high', 4);
      throw error;
    }
  }

  async function clearUserReminders() {
    try {
      await clearUserRemindersMutate({ assignedid: user.userid });
    } catch (error) {
      console.error('Error clearing all reminders:', error);
      addAlert('Error clearing all reminders', 'high', 4);
    }
  }

  return {
    updateReminder,
    addReminder,
    deleteReminder,
    clearUserReminders,
    loading,
    error,
  };
}
